var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWeChat)?_c('div',[(_vm.isIOS)?_c('img',{staticClass:"mask",attrs:{"src":require("../../assets/wechat_mask_ios.jpg")}}):_c('img',{staticClass:"mask",attrs:{"src":require("../../assets/wechat_mask_android.png")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }